import type { CategoryType } from "./";

export function hasCategory(category: CategoryType, slug: string) {
  return category.slug === slug || category.parent?.slug === slug;
}
